import angular from 'angular'
import { add } from 'vend-number'
import { RegisterManager } from '../../managers/register-manager'

/**
 * Represents the sale discount value
 *
 * @module webregister.directives.wrSaleDiscountValue
 */
angular
  .module('webregister.directives')
  .directive('wrSaleDiscountValue', function () {
    return {
      restrict: 'E',
      scope: {
        saleDiscount: '<',
      },
      template: '<b>{{ctrl.getDiscount() | vdCurrency}}</b>',
      controllerAs: 'ctrl',
      bindToController: true,
      controller(this: $TSFixMe, registerManager: RegisterManager) {
        const isTaxInclusive = registerManager.isTaxInclusive()

        /**
         * Determine the current discount value
         *
         * @method getDiscount
         *
         * @return {Number} Returns the display discount value
         */
        this.getDiscount = function (): number {
          let discountValue: number

          // Check that the sale has a discount set
          if (this.saleDiscount && this.saleDiscount.price) {
            const { price, tax } = this.saleDiscount

            if (isTaxInclusive) {
              discountValue = add(price, tax)
            } else {
              discountValue = price
            }
          } else {
            // If no discount is present assume 0
            discountValue = 0
          }

          return -discountValue
        }
      },
    }
  })
